import React from 'react';
import { connect } from 'react-redux';
import { useIntl } from 'react-intl';
import findResult from '@/utils/resultsHelper';
import { readStates, states } from '@/constants/lifecycle';
import urls, { relativeUrl, startsWithUrl } from '@/constants/urls';
import { requestSources } from '@/requests/constants';
import NotFound from '@/components/errors/NotFound';
import PanelContainer from '@/components/wrappers/PanelContainer';
import fetch from '@/hooks/fetch';
import { fetchSystemCohort } from '../actions';

const SystemCohortPanelContainer = ({
  category,
  code, // requestCode
  request,
  exists,
  readStatus,
  validationErrors,
  saveErrors,
  name,
  description,
  canRead,
  url,
  onChange,
  fetchData,
  children,
}) => {
  const intl = useIntl();
  fetch.useFetchByCode(fetchData, category, code, readStatus);
  if (request && request.request_source !== requestSources.COHORT) {
    return <NotFound />;
  }

  if (onChange && readStatus === states.SUCCESS) {
    const title = intl.formatMessage({ id: 'tabs.cohort.of' }, { name: request?.name });
    onChange({ url, title });
  }

  return (
    <PanelContainer
      canAccess={canRead}
      description={description}
      entity="cohort"
      exists={exists}
      name={name}
      onChange={onChange}
      readStatus={[readStatus]}
      saveErrors={saveErrors}
      url={url}
      validationErrors={validationErrors}
    >
      {children}
    </PanelContainer>
  );
};

const accessControl = (role, exists) => (
  {
    exists,
    canRead: exists ? role.permissions.requests.read : false,
  }
);

const withoutItem = (role, url) => (
  {
    ...accessControl(role, false, startsWithUrl(url, relativeUrl(urls.COHORTS))),
    ...readStates,
    queryAccess: false,
    allowCohortVisualisations: false,
    expandedCharts: false,
    datasetCohortVisibilities: [],
    canEdit: false,
  }
);

const withItem = (item, role, url) => (
  {
    ...accessControl(role, true, false),
    exists: true,
    canEdit: false,
    cohortCode: item.code,
    url,
    isEditing: false,
    readStatus: item.readStatus,
    readErrors: item.readErrors,
    validationErrors: item.validationErrors,
    queryAccess: item.access.query_access,
    allowCohortVisualisations: item.settings.expose_cohort_visualisations,
    expandedCharts: item.expandedCharts,
    activeQueryUUID: item.activeQueryUUID,
    request: item.request,
    userCohort: item.user_cohort,
  }
);

export const mapStateToProps = ({
  auth: { role },
  cohorts: { cohorts },
}, { category, code, url }) => {
  const item = findResult(cohorts, category, code, 'requestCode');
  return item ? withItem(item, role, url) : withoutItem(role, url);
};

export const mapDispatchToProps = {
  fetchData: fetchSystemCohort,
};

export default connect(mapStateToProps, mapDispatchToProps)(SystemCohortPanelContainer);
